import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from "@angular/material";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { ToastrService } from "ngx-toastr";
import beautify from "xml-beautifier";
import { LoginService } from "src/app/components/Shared/Service/login_service";
import { DashboarduiService } from "../Shared/Service/dashboardui.service";
import { interval } from "rxjs";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { ExcelServicesService } from "../Shared/Service/excel-services";

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "LL",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

export class idsProductList {
  echotoken: any;
  totalCount: number;
  id: number;
  pmscode: String;
  processstatus: String;
  rateType: String;
  mealPlanCode: any;
  startdt: any;
  enddt: any;
  receivedXML: any;
  receivedDate: any;
  postedXML: any;
  postedDate: any;
  responseXML: any;
  responseDate: any;
}

@Component({
  selector: 'app-rate-pms-newpipe',
  templateUrl: './rate-pms-newpipe.component.html',
  styleUrls: ['./rate-pms-newpipe.component.css'],
  providers: [
    LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class RatePmsNewpipeComponent implements OnInit {

  math = Math;
  searchText = "";
  public PGF: any = 0;
  public PGT: any = 50;
  pageSize = 50;
  isIDSUser: any;
  apiresult: any;
  hotellistproperty: any;
  XMLTitle: string;
  status: void;
  hotelSearchDataStatus: any;
  heartBeatData: any;
  errorMessage: string;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  productType: any;
  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean;
  requestPayload: any;
  filterProperty: any
  excelFunction: boolean = false;
  constructor(private excelService: ExcelServicesService,private toastr: ToastrService,private datePipe: DatePipe,
    private apiCallIdsService: DashboarduiService, public loginService: LoginService) { }
  today = new Date();
  display: Boolean = false;
  totalcount: any = 0;
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>
  StorelstRestr: any;
  // dataSource: MatTableDataSource<RestrictionClass>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  Val: string;
  selectedProperty: string;
  defaultData: any = [];
  User: string;
  selectedDate: any = new Date();
  selectedTOODate: any = new Date();
  todayFuture: any = new Date();
  minDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() - 30));
  todayFutureOneDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() + 1));
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  hotellist: any = [];
  selected: string;
  Userid: any = [];
  addBtnDisabledFunc: boolean = true;
  displayedColumns: string[] = ['Status', 'token', 'ratecode', 'mealPlanCode', 'createdatetime', 'lastupdatedatetime', 'Request', 'ReqStatus'];
  /* Search Field */
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any
  searchBarFilter: boolean = false;

  hideSearchFilter() {
    this.searchText = '';
    this.searchBarFilter = false
  }
  ngOnInit() {
    // this.isIDSUser = this.loginService.isIDSUser();
    this.isProgressing = true;
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.callIDSUsersProperties();
    this.dropdownSettingsDept = {
      idField: 'pmscode',
      textField: 'pmsname',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getFXCRSNewPipeProperty()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          this.hotellistproperty = this.apiresult;
          this.dropdownDeptData = this.apiresult;
          console.log('Property 113 = ', data)
          this.isProgressing = false;
        });


  }

  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      this.searchBarFilter = false
      this.searchText = '';
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.Pmscodevalue = this.selectedDeptItems[0].pmscode
        console.log('pms code value = ', this.Pmscodevalue)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.addBtnDisabledFunc = false
        // For Online Status
        this.apiCallIdsService
          .readHotelSearch(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHotelSearch =', data)
            this.hotelSearchDataStatus = data[0].recordstatus
            this.productType = data[0].producttype
          });
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat

            // For blinking the record
            const today = new Date()
            console.log('Today Date = ', today);
            this.currentDateStore = today.toLocaleTimeString('it-IT')
            console.log('Today Date = ', this.currentDateStore);
            this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
            var start = this.storeHeartBeatValue.split(":");
            var end = this.currentDateStore.split(":");
            var startDate = new Date(0, 0, 0, start[0], start[1], 0);
            var endDate = new Date(0, 0, 0, end[0], end[1], 0);
            var diff = endDate.getTime() - startDate.getTime();
            var hours = Math.floor(diff / 1000 / 60 / 60);
            diff -= hours * 1000 * 60 * 60;
            var minutes = Math.floor(diff / 1000 / 60);
            // console.log('minutes difference',minutes)
            console.log('minutes difference', hours + ":" + minutes)
            if ((hours + ":" + minutes) > "0:30") {
              console.log('blinkOfflineHotel true')
              this.blinkOfflineHotel = true
            } else {
              console.log('blinkOfflineHotel false')
              this.blinkOfflineHotel = false
            }
          });
        interval(2000 * 60).subscribe(() => {
          this.heartbeatFunction();
        });
      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.addBtnDisabledFunc = true
        this.excelFunction = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  heartbeatFunction() {
    this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =', data[0])
        this.heartBeatData = data[0].heartBeat
      });
  }


  GetParseonlyDateTime(d: any) {
    console.log('GetParseonlyDateTime call', d.substring(12))
    return (d.substring(12));
  }

  pageEvent(e: any) {
    console.log('pageEvent = ', e)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.PGF = this.pageSize * pageIndex + 1;
    this.PGT = this.PGF + e.pageSize - 1;
    console.log("this.PGF", this.PGF)
    console.log("this.PGT", this.PGT)
    this.loadMethodForRateSyncLog();
  }

  loadMethodForRateSyncLog() {
    this.searchBarFilter = true
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    }
    else {
      this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
      this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
      this.isProgressing = true;
      // this.PGF = 0;
      // this.PGT = 50;
      console.log('pageSize == ',this.pageSize)
      console.log('PGF == ',this.PGF)
      console.log('PGT == ',this.PGT)
      console.log('selectedDate == ',this.selectedDate)
      console.log('selectedTOODate == ',this.selectedTOODate)
      this.requestPayload = {
        "PMSCODE": this.Pmscodevalue,
        "FRMDATE": this.selectedDate,
        "TOODATE": this.selectedTOODate,
        "TOKEN": this.searchText,
        "PaginationFromId": this.PGF,
        "PaginationToId": this.PGT
      }
      console.log("this.requestPayload ==", this.requestPayload)
      this.apiCallIdsService.getRatePMSNewPipelog(this.requestPayload)
        .subscribe((res) => {
          this.StorelstRestr = res;
          if (this.StorelstRestr[0].totalCount < 1) {
            this.toastr.error('No Data Found');
            this.totalcount = this.StorelstRestr[0].totalCount;
            console.log(this.totalcount)
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.displayContent = false
            this.excelFunction = false
            this.isProgressing = false;

          } else {
            this.idsProductList = res;
            console.log('response ==',this.StorelstRestr)
            this.totalcount = this.StorelstRestr[0].totalCount;
            console.log('totalcount ==',this.totalcount)
            this.errorMsgSubscription = false
            this.displayContent = true
            this.excelFunction = true
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          }
        });
    }
  }

  FOOTFALL() {
    this.User = localStorage.getItem("Username");
    this.apiCallIdsService.getfootfall(this.User, 'Channel manager', 'restriction').subscribe(
      data => {
      });
  }

  closeModalDialog() {
    this.display = false;
  }

  // Rate XML loading
  showXml(xmltype: any, token: any) {
    this.isProgressing = true;
    this.apiCallIdsService.getRatePMSNewPipeXML(token, xmltype)
      .subscribe((res) => {
        console.log('Response =', res)
        if (xmltype == 'Request') {
          this.XMLTitle = "Request JSON"
        } else if (xmltype == 'Status') {
          this.XMLTitle = "Response JSON"
        }
        const xml = beautify(res[0].xmlData);
        console.log('Beautifier', xml);
        this.defaultData = xml;
        this.display = true;
        this.isProgressing = false;

      })
  }

    /* Excel Download */

    exportAsXLSX() {
      this.Userid = localStorage.getItem("Username");
      console.log(this.Userid)
      var filterArray = [];
      var slno = 1;
      const excelTitle = "Rate Delivery to PMS NewPipe";
      const excelDownloadTitle = "Rate Delivery to PMS NewPipe";
      const title = "Title: " + excelTitle;
      const role = "Role: " + "IDS User";
      const bindFirstName = "EmailId: " + this.Userid;
      const header = ['S.NO','Status','Hotel Code','Token', 'Rate Code', 'Meal PlanCode', 'Created Date','Last Updated Date','Req JSON','Res JSON'];
      for (var i in this.filterProperty) {
        filterArray.push([
          slno, this.filterProperty[i].status,this.filterProperty[i].pmscode,,this.filterProperty[i].token, this.filterProperty[i].ratecode, this.filterProperty[i].mealPlanCode, this.datePipe.transform(this.filterProperty[i].createdatetime, 'dd-MMM-yyyy, HH:mm'),this.datePipe.transform(this.filterProperty[i].lastupdatedatetime, 'dd-MMM-yyyy, HH:mm'),"XML","XML"
        ])
        slno = slno + 1;
      }
  
      this.excelService.ExcelRateDeliveryToPMS(filterArray, bindFirstName, title, role, header, excelTitle, excelDownloadTitle);
    }

}
